export default __webpack_public_path__ + "static/media/image-cushion-b-w@3x.d9730854.png";